import React, { useEffect, useState } from 'react'
import { Card, Input, Button, Table, Space, Pagination, Form, Select, Tag, message } from 'antd'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { getPreSelectionListAPI, addCustomerAPI, addPreSelectionAPI } from '@/apis/user'
import { checkMenu, checkLogin } from '@/utils'
import Dayjs from 'dayjs'
const { Column } = Table
///
export default function PreSelectionList() {
  const navigate = useNavigate()
  const location = useLocation()

  const [listLoading, setListLoading] = useState(false) //  表格加载状态
  //  列表请求参数
  const [listQuery, setListQuery] = useState({
    keywords: '',
    isCustomer: undefined, //	是否加客资，-1：全部；0：否；1：是
    pageInt: 1,
    pageSize: 100
  })
  const [total, setTotal] = useState(0) //  列表总数
  const [list, setList] = useState([]) //  获取列表
  const [isCustomerList] = useState([
    { value: 0, label: '否' },
    { value: 1, label: '是' }
  ])

  //  翻页
  const onChange = (page, pageSize) => {
    listQuery.pageInt = page
    listQuery.pageSize = pageSize
    setListQuery({
      ...listQuery,
      pageInt: page,
      pageSize: pageSize
    })
    fetchData()
  }
  //  搜索
  const searchFinish = values => {
    listQuery.keywords = values.keywords
    listQuery.isCustomer = values.isCustomer === 0 || values.isCustomer === 1 ? values.isCustomer : undefined
    listQuery.pageInt = 1
    setListQuery({
      ...listQuery
    })
    fetchData()
  }

  //  获取客资列表
  const fetchData = async () => {
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
      return
    }
    setListLoading(true)
    const nowTime = new Date().getTime()
    const today = new Date(Dayjs().format('YYYY-MM-DD')).getTime()
    const res = await getPreSelectionListAPI(listQuery)
    if (res.success === true) {
      if (res.result.list) {
        res.result.list.forEach((item, index) => {
          item.key = index
          item.loading = false
          item.preSelectionLoading = false
          if (item.nickname) {
            item.nickname = decodeURIComponent(item.nickname)
          } else {
            item.nickname = '暂无昵称' + item.userId.toString().slice(-4)
          }
          item.isNewStatus = 0
          if (Dayjs(item.firstVisitTime).unix() * 1000 > today) {
            item.isNewStatus = 1
          } else if (Dayjs(item.firstVisitTime).unix() * 1000 + 7 * 86400000 >= nowTime) {
            item.isNewStatus = 2
          }
          item.firstVisitTime = Dayjs(item.firstVisitTime).format('YYYY-MM-DD')
          item.newVisitTime = Dayjs(item.newVisitTime).format('YYYY-MM-DD')
        })
      }
      setList(res.result.list)
      setTotal(res.result.total)
    }
    setListLoading(false)
  }
  
  const addCustomer = async (row) => {
    list[row.key].loading = true
    setList([...list])
    let isCustomer = row.isCustomer && row.isCustomer === 1 ? 0 : 1
    let params = {
      userId: row.userId,
      isCustomer,
      houseId: row.houseId
    }
    const res = await addCustomerAPI(params)
    if (res.success === true) {
      message.success('加客资成功')
      fetchData()
    } else {
      message.error(res.message)
      list[row.key].loading = false
      setList([...list])
    }
  }
  //  预选
  const addPreSelection = async (row) => {
    list[row.key].preSelectionLoading = true
    setList([...list])
    let params = {
      userId: row.userId,
      isPreSelection: 0,
      houseId: row.houseId
    }
    const res = await addPreSelectionAPI(params)
    if (res.success === true) {
      message.success('取消预选成功')
      fetchData()
    } else {
      message.error(res.message)
      list[row.key].preSelectionLoading = false
      setList([...list])
    }
  }

  useEffect(() => {
    if(!checkMenu(location.pathname)) {
      navigate('/managecenter/404')
      return
    }
    fetchData()
  }, [])

  return (
    <div>
      <div className="pageTitle">
        <div className="pageTitle-name">我的客资</div>
      </div>
      <Card className="card">
        <div className="flex-between">
          <Form initialValues={listQuery} onFinish={searchFinish} className="searchForm">
            <Form.Item name="keywords">
              <Input allowClear placeholder="用户昵称" style={{ width: '200px' }} />
            </Form.Item>
            <Form.Item name="isCustomer">
                <Select allowClear options={isCustomerList} placeholder="是否已加客资" style={{ width: '250px', marginLeft: '10px' }} />
            </Form.Item>
            <Form.Item>
              <Button type="primary" className="searchBtn" htmlType="submit" style={{ marginLeft: '10px' }}>
                搜索
              </Button>
            </Form.Item>
          </Form>
        </div>

        <Table dataSource={list} loading={listLoading} pagination={false}>
          <Column
            title="昵称"
            render={(_, record) => (
              <Space size="middle">
                {record.nickname}
                {record.isNewStatus == 1 ? <div className="red">今日首访</div> : record.isNewStatus == 2 ? <div className="green">新客</div> : ''}
              </Space>
            )}
          />
          <Column
            title="标签"
            key="labelList"
            render={(_, record) => (
              <Space size="middle">
                {record.labelList && record.labelList.map((item, index) => {
                  return (
                    <Tag key={index}>{item.tagName}</Tag>
                  )
                })}
              </Space>
            )}
          />
          <Column title="7日有效访问" dataIndex="weekVisitorNum" />
          <Column title="30天" dataIndex="monthVisitorNum" />
          <Column title="90天" dataIndex="quarterVisitorNum" />
          <Column title="180天" dataIndex="halfYearVisitorNum" />
          <Column title="首次访问" dataIndex="firstVisitTime" />
          <Column title="最近访问" dataIndex="newVisitTime" />
          <Column
            title="操作"
            key="action"
            render={(_, record) => (
              <Space size="middle">
                <Link target="_blank" to={'/managecenter/user/detail/' + record.userId} className="color-576b95">
                  画像
                </Link>
                <Button type="link" loading={record.preSelectionLoading} onClick={() => addPreSelection(record)} className="color-576b95">取消预选</Button>
                {Number(record.isCustomerStatus) == 1 ? (
                  <span className="gray">已加客资</span>
                ) : (
                  <Button type="link" loading={record.loading} onClick={() => addCustomer(record)} className="color-576b95">
                    加客资
                  </Button>
                )}
              </Space>
            )}
          />
        </Table>
        <Pagination hideOnSinglePage defaultPageSize={20} showTotal={total => '共 ' + total + ' 条数据'} pageSize={listQuery.pageSize} pageSizeOptions={['10', '20', '30', '50', '100']} total={total} showSizeChanger showQuickJumper onChange={onChange} />
      </Card>
    </div>
  )
}
